/* Fast video (v47).
   Every video used to start downloading at page load, all at once, so they
   competed for the same bandwidth and the one you were looking at loaded
   slowly. Now:
   - Videos on screen (or about to be) load first, at full priority.
   - Videos further down wait (download is paused) until you scroll near them,
     then start ~1 screen early so they are ready when they appear.
   - Videos that leave the screen pause, freeing bandwidth for the next one.
   - All are muted + playsinline so phones autoplay them like GIFs.
   - Videos the customer started with sound/controls are never touched. */
(function(){
var AHEAD=window.innerHeight*1.2;
function near(v){var r=v.getBoundingClientRect();return r.bottom>-AHEAD&&r.top<window.innerHeight+AHEAD;}
function park(v){
if(v.dataset.ifv)return;v.dataset.ifv='1';
if(v.controls&&!v.muted)return;
v.muted=true;v.setAttribute('muted','');v.playsInline=true;v.setAttribute('playsinline','');
if(near(v)){v.preload='auto';v.setAttribute('fetchpriority','high');return;}
var srcs=v.querySelectorAll('source[src]');
if(v.getAttribute('src')){v.dataset.ifsrc=v.getAttribute('src');v.removeAttribute('src');}
[].forEach.call(srcs,function(s){s.dataset.ifsrc=s.getAttribute('src');s.removeAttribute('src');});
v.preload='none';
try{v.load();}catch(e){}
v.dataset.ifparked='1';
}
function wake(v){
if(!v.dataset.ifparked)return;delete v.dataset.ifparked;
if(v.dataset.ifsrc)v.setAttribute('src',v.dataset.ifsrc);
[].forEach.call(v.querySelectorAll('source'),function(s){if(s.dataset.ifsrc)s.setAttribute('src',s.dataset.ifsrc);});
v.preload='auto';
try{v.load();}catch(e){}
}
function play(v){if(v.dataset.ifparked)return;if(v.autoplay||v.loop||v.muted){var p=v.play();if(p&&p.catch)p.catch(function(){});}}
var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){wake(v);play(v);}else if(!v.controls||v.muted){if(!v.paused)v.pause();}});},{rootMargin:Math.round(AHEAD)+'px 0px'}):null;
function scan(){[].forEach.call(document.querySelectorAll('video'),function(v){if(v.dataset.ifvo)return;park(v);if(io){v.dataset.ifvo='1';io.observe(v);}else{wake(v);}});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
var k=0;var iv=setInterval(function(){scan();if(++k>30)clearInterval(iv);},500);
})();
